import AppChannel from "../AppChannel";

export default class UserProfileChannel extends AppChannel {

}
